import {
  PRESUPUESTADOR_SOLICITAR_PERITAJE_BEGIN,
  PRESUPUESTADOR_SOLICITAR_PERITAJE_SUCCESS,
  PRESUPUESTADOR_SOLICITAR_PERITAJE_FAILURE,
  PRESUPUESTADOR_SOLICITAR_PERITAJE_DISMISS_ERROR,
  PRESUPUESTADOR_SOLICITAR_PERITAJE_PATENTE
} from './constants'
import { REACT_APP_PERITADOR_API } from '../../../common/config'
import axios from 'axios'
import { BUSINESS_UNIT } from 'common/Constants';

export function solicitarPeritaje(auto, customer) {
  const { patente, quotation_id } = auto
    return (dispatch, getState) => { // optionally you can have getState as the second argument
      const state = getState()
      if(!state.presupuestador.nuevo){
        dispatch({
          type: PRESUPUESTADOR_SOLICITAR_PERITAJE_FAILURE,
          data: { error: "Se debe ingresar un vehículo nuevo ", patente },
        });
        return
      }
    if(patente){  
      dispatch({
        type: PRESUPUESTADOR_SOLICITAR_PERITAJE_BEGIN,
        data: { patente }
      });

      if(customer.nombre &&
        customer.apellido &&
        customer.email &&
        customer.telefono) {        
        const unidadNegocio = state.presupuestador.nuevo.nuevo ? BUSINESS_UNIT['0KM'] : BUSINESS_UNIT['USADOS']
        const hasLeadId = (!!state.presupuestador.lead_id) ||
          (state.presupuestador.Budget_CRM_Integration?.origin === 'lead' && state.presupuestador.Budget_CRM_Integration?.external_id)

        // Esto es porque el peritaje necesita origin_channel_id y no businessUnit
        let origin_channel_id = state.peritador?.originChannels.find(oc => String(oc.name).toLowerCase() === String(unidadNegocio).toLowerCase())?.id;

        const objSolicitud = {
          serviceDate: new Date(),
          servicePatent: patente,
          observations: "",
          email: "",
          client_id: state.presupuestador.cliente.id_cliente,
          origin_channel_id,
          origin_request_type: 'Presupuesto',
          branch_office_id: state.presupuestador.nuevo.branch_office_id,
          car_lot_id: state.presupuestador.nuevo.car_lot_id,
          serviceAddress: {
            address: "",
            location: ""
          },
          customer: {
            identifierType: customer.tipoDoc,
            identifier: customer.documento,
            name: customer.nombre,
            lastname: customer.apellido,
            contact: customer.telefono,
            email: customer.email,
          },
          typeRequest: "automatic",
          statusId: "1",
          external_id: state.presupuestador.external_id || null,
          platform: state.presupuestador.platform || null,
        }

        if (hasLeadId) {
          const leadId = (state.presupuestador.Budget_CRM_Integration?.origin === 'lead') ?
            state.presupuestador.Budget_CRM_Integration.external_id :
            state.presupuestador.lead_id
          objSolicitud.external_id = leadId
          objSolicitud.origin = 'lead'
          objSolicitud.target = 'request'
          objSolicitud.platform = 'asofix'
        }

        const promise = new Promise((resolve, reject) => {

          const doRequest = axios.post(REACT_APP_PERITADOR_API+'/requests', objSolicitud)
          doRequest.then(
            (res) => {
              dispatch({
                type: PRESUPUESTADOR_SOLICITAR_PERITAJE_SUCCESS,
                data: { res, patente },
              });
              resolve(res);
            },
            // Use rejectHandler as the second argument so that render errors won't be caught.
            (err) => {
              dispatch({
                type: PRESUPUESTADOR_SOLICITAR_PERITAJE_FAILURE,
                data: { error: err.message, patente },
              });
              reject(err);
            },
          );
        });

        return promise;

      } else {
        dispatch({
          type: PRESUPUESTADOR_SOLICITAR_PERITAJE_FAILURE,
          data: { error: "Se deben completar todos los datos del cliente", patente },
        });
      }
    } else {
      dispatch({
        type: PRESUPUESTADOR_SOLICITAR_PERITAJE_PATENTE,
        data: { error: "Primero ingrese la patente", quotation_id },
      });
    }
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSolicitarPeritajeError() {
  return {
    type: PRESUPUESTADOR_SOLICITAR_PERITAJE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SOLICITAR_PERITAJE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        entregaUsados: state.entregaUsados.map((usado) => {
          if (usado.patente === action.data.patente) {
            return {
              ...usado,
              pendingPeritaje: true,
              errorPeritaje: null,
            }
          } else {
            return usado
          }
        }),
      };

    case PRESUPUESTADOR_SOLICITAR_PERITAJE_SUCCESS:
      // The request is success
      return {
        ...state,
        entregaUsados: state.entregaUsados.map((usado) => {
          if (usado.patente === action.data.patente) {
            return {
              ...usado,
              peritado: action.data.res.data.statusId,
              quotation_id: action.data.res.data.id,
              requestsId: action.data.res.data.id,
              pendingPeritaje: false,
              errorPeritaje: null,
            }
          } else {
            return usado
          }
        }),
        Taking_cars: state.Taking_cars.map((usado) => {
          if (usado.license_plate === action.data.patente) {
            return {
              ...usado,
              requestsId: action.data.res.data.id,
            }
          } else {
            return usado
          }
        }),
      };

    case PRESUPUESTADOR_SOLICITAR_PERITAJE_PATENTE:
      // The request is failed
      return {
        ...state,
        entregaUsados: state.entregaUsados.map((usado) => {
          if (usado.quotation_id === action.data.quotation_id) {
            return {
              ...usado,
              pendingPeritaje: false,
              errorPeritaje: action.data.error,
            }
          } else {
            return usado
          }
        }),
      };

    case PRESUPUESTADOR_SOLICITAR_PERITAJE_FAILURE:
      // The request is failed
      return {
        ...state,
        entregaUsados: state.entregaUsados.map((usado) => {
          if (usado.patente === action.data.patente) {
            return {
              ...usado,
              pendingPeritaje: false,
              errorPeritaje: action.data.error,
            }
          } else {
            return usado
          }
        }),
      };

    case PRESUPUESTADOR_SOLICITAR_PERITAJE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        solicitarPeritajeError: null,
      };

    default:
      return state;
  }
}
